<template>
  <div class="tabs-pane">
    <transition :name="paneTransitionName">
      <div class="tab-pane-content" v-if="$parent.activeName === name" :key="$parent.activeName">
        <slot name="default"></slot>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    cnLabel: {
      type: String
    },
    enLabel: {
      type: String
    },
    name: {
      type: String
    },
  },
  data() {
    return {
      paneTransitionName: "enter-right",
    };
  },
  created() {
    this.$parent.setTabBar(this);
  },
};
</script>
<style lang="less">
.tabs-pane {
  overflow-x: hidden;

  .enter-right-enter-active {
    transition: transform 0.35s;
  }

  .enter-right-enter {
    transform: translateX(100%);
  }

  .enter-right-to {
    transform: translateX(0);
  }

  .tab-pane-content {
    padding: 10px;
  }
}
</style>
